import type { ApiErrorResponse } from '../../../schema/error/entry.js';
import { HttpStatus, type HttpStatusCode } from '../../lib/entry.js';
import { PoolbettingError } from './PoolbettingError.js';

export class ApiError extends PoolbettingError<'INTERNAL'> {
  protected override httpStatus: HttpStatusCode = HttpStatus.InternalServerError;

  private readonly _apiCode: number;

  // The backend API code is the established second argument of this public error type.
  // eslint-disable-next-line unicorn/custom-error-definition
  constructor(message: string, apiCode: number) {
    super(message, undefined, 'INTERNAL');
    this.name = 'ApiError';
    this._apiCode = apiCode;
  }

  get apiCode(): number {
    return this._apiCode;
  }

  static fromBackendError(error: ApiErrorResponse): ApiError {
    return new ApiError(error.message, error.code);
  }

  toJSON(): { code: number; message: string } {
    return {
      code: this._apiCode,
      message: this.message,
    };
  }

  override toString(): string {
    return JSON.stringify(this.toJSON());
  }
}
